import React from 'react';

import { CreateIconComponent } from './CreateIconComponent';

export const AutoreviewIllustration = CreateIconComponent(
  <svg
    width="183"
    height="183"
    viewBox="0 0 183 183"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M115.233 69.3486C96.2467 69.3486 81.3398 84.103 75.6782 91.4611C79.4526 98.8383 96.2467 113.574 115.233 113.574C134.219 113.574 151.013 98.8193 154.788 91.4611C149.145 84.0839 134.219 69.3486 115.233 69.3486ZM115.233 75.4486C124.078 75.4486 131.245 82.6161 131.245 91.4611C131.245 100.306 124.078 107.474 115.233 107.474C106.388 107.474 99.2204 100.306 99.2204 91.4611C99.2204 82.6161 106.388 75.4486 115.233 75.4486Z"
      fill="#1868DB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M114.127 91.4996L125.584 105.434L115.519 122.896L97.6952 119.922L91.3855 136.83H71.2364L64.8886 119.922L47.0652 122.896L37.0192 105.434L48.4567 91.4996L37.0192 77.5649L47.0652 60.1036L64.8886 63.0583L71.2364 46.1689H91.3855L97.6952 63.0583L115.519 60.1036L125.603 77.5649L114.127 91.4996Z"
      fill="#FCA700"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M115.233 107.493C106.388 107.493 99.2205 100.306 99.2205 91.4611C99.2205 82.6161 106.388 75.4486 115.233 75.4486C118.798 75.4486 122.096 76.6114 124.764 78.5939L125.603 77.5646L121.142 69.8252C119.236 69.5202 117.254 69.3486 115.233 69.3486C96.2468 69.3486 81.3399 84.0839 75.6974 91.4611C79.4527 98.8383 96.2468 113.574 115.233 113.574C117.235 113.574 119.217 113.402 121.161 113.097L125.584 105.434L124.726 104.386C122.057 106.33 118.779 107.493 115.233 107.493Z"
      fill="#164B35"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M114.127 91.4998L124.726 104.386C122.057 106.33 118.778 107.493 115.233 107.493C106.388 107.493 99.2202 100.307 99.2202 91.4617C99.2202 82.6167 106.388 75.4492 115.233 75.4492C118.797 75.4492 122.095 76.612 124.764 78.5945L114.127 91.4998Z"
      fill="#FCA700"
    />
  </svg>
);

export default AutoreviewIllustration;
